import { Component, OnInit , ViewChild,Output,EventEmitter} from '@angular/core';
import { HttpErrorResponse ,HttpClient} from '@angular/common/http';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import {MatSnackBar} from '@angular/material';
import { AppSettings } from '../../app.constant';
import { CategoryService } from '../../shared/services/category.service';
import { CategoryTableComponent } from '../../private/tables/category-table/category-table.component';
import { NotificationComponent } from 'src/app/private/widget/notification/notification.component';


@Component({
  selector: 'category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})

export class CategoryComponent implements OnInit {
  categoryForm:FormGroup;
  httpResponseMessage:any;
  submitted=false;
  post:any;
  categoryentity:any;
  CategoryName:string = '';
  PK_CategoryID:any = '';
  errorMessage: String;
  buttonTitle:String =  'S A V E ';
  newtitle:String =" N E W ";
  testimonials: string [];

  @ViewChild(CategoryTableComponent) categorytable;
  constructor(
    private FormBuilder:FormBuilder, 
    private CategoryService:CategoryService,
    private snackBar: MatSnackBar,
    private httpService: HttpClient
    ) {  }

  ngOnInit() {
    this.categoryForm = this.FormBuilder.group({
      'PK_CategoryID':[''],
      'CategoryName': ['', [Validators.maxLength(250), Validators.required]]
    })

    this.httpService.get('assets/json/testimonial.json').subscribe(
      data => {
        this.testimonials = data as string [];	 // FILL THE ARRAY WITH DATA.
        //  console.log(this.arrBirds[1]);
      },
      (err: HttpErrorResponse) => {
        console.log (err.message);
      }
   );
  }

  public hasError = (controlName: string, errorName: string) =>{
    return this.categoryForm.controls[controlName].hasError(errorName);
  }

  postCategory(post) :void  {
    if(post.PK_CategoryID !='' && post.PK_CategoryID != null) {
      this.updateCategory(post);
    }
    else{
     this.saveCategory(post);
    }
  }


  cleardata()
  {
    this.categoryForm.reset();
  }










  updateCategory(post) {
    if (this.categoryForm.invalid) {  return; }
    this.post=JSON.stringify(post);
    this.CategoryService.updateCategory(AppSettings.API_ENDPOINT+AppSettings.UpdateCategory,this.post).subscribe(
      data => {   
          this.httpResponseMessage=data
          this.openSnackBar(this.httpResponseMessage,'');
          this.categoryForm.reset();
        },
          error => this.errorMessage = <any>error)
  }

  saveCategory(post) :void  {
    if (this.categoryForm.invalid) {
      return;
    }
          this.post=JSON.stringify(post);
          this.CategoryService.postCategory(AppSettings.API_ENDPOINT+AppSettings.CreateCategory,this.post).subscribe(
      data =>{
          this.httpResponseMessage=data
          this.openSnackBar(this.httpResponseMessage,'');
          this.categoryForm.reset();
        },
      error => this.errorMessage = <any>error)
  }

  receiveData($event) {
    this.categoryentity = $event
    if(this.categoryentity[0].CategoryName)    {
    this.CategoryName=this.categoryentity[0].CategoryName;
    this.PK_CategoryID=this.categoryentity[0].PK_CategoryID;

    }
  }

  durationInSeconds = 2;
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message,action ,{
      duration: 2000,
      verticalPosition: 'bottom'
    });
    }
}

